import api from '../../plugins/api';

/**
 * POST /crm/cars/createConsignment — привязывает к уже созданному авто продавца
 * (клиента CRM), реквизиты ДЦ и счёт продавца. После сохранения менеджер сразу
 * переходит к созданию сделки.
 *
 * @param {Object} params
 * @param {number} params.carId
 * @param {number} params.sellerClientId — id клиента-доверителя
 * @param {number} params.price — цена продажи по договору
 * @param {Object} params.requisites — реквизиты ДЦ (поверенного)
 * @param {Object} params.sellerRequisites — счёт продавца: recipient, iban, bankName, bic
 * @returns {Promise<{ data: { consignmentId: number } }>}
 */
const createConsignment = (params) => {
  return api.post('/api/crm/cars/createConsignment', params);
};

export default createConsignment;
